import { withDataVersion } from '@hakimo-ui/hakimo/util';
import { DataVersion, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDispatchLocationAlarm(
  alarmId: string,
  options?: {
    onSuccess?: () => void;
    onError?: () => void;
    product?: UnifiedMonitoringProduct;
    dataVersion?: DataVersion;
  }
) {
  const {
    onSuccess,
    onError,
    product = UnifiedMonitoringProduct.REMOTE_GUARDING,
    dataVersion,
  } = options ?? {};
  const url = `/v2/orm/location_alarms/dispatch/${alarmId}?product=${product}`;

  const request = new Request(url, { method: 'POST' });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, FormData | string>(request, {
    getBody: (payload) => payload,
    responseModifier: async (response) => {
      const contentType = response.headers.get('content-type');
      if (contentType?.includes('application/json')) return response.json();
      return null;
    },
    onSuccessInvalidationKeys: [
      ['location_alarm_updates', alarmId],
      ['locationAlarms', alarmId],
    ],
    onSuccess,
    onError,
  });
}

export default useDispatchLocationAlarm;
